import { IInventoryItem } from "@interfaces/user/items";
import { createContext, useContext } from "react";

export const InventoryItemContext = createContext<IInventoryItem>(undefined as any);
export const InventoryItemProvider = InventoryItemContext.Provider;

export function useInventoryItemContext(): IInventoryItem | undefined {
    return useContext(InventoryItemContext);
}